import { render } from "./BidShowcase23zaym.vue?vue&type=template&id=520b36fc&scoped=true"
import script from "./BidShowcase23zaym.vue?vue&type=script&lang=js"
export * from "./BidShowcase23zaym.vue?vue&type=script&lang=js"

import "./BidShowcase23zaym.vue?vue&type=style&index=0&id=520b36fc&scoped=true&lang=css"
import "./BidShowcase23zaym.vue?vue&type=style&index=1&id=520b36fc&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520b36fc"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QSelect,QForm,QInput});
